export const nav = [
  {
    text: "home",
    path: "/",
  },
  {
    text: "about",
    path: "/about",
  },
  {
    text: "services",
    path: "/services",
  },
  // {
  //   text: "blog",
  //   path: "/blog",
  // },
  // {
  //   text: "pricing",
  //   path: "/pricing",
  // },
  {
    text: "contact",
    path: "/contact",
  },
]
export const featured = [
  {
    cover: "../images/service1.png",
    heading: "Security Services",
    text: "We offer a full range of security solutions, including armed and unarmed security personnel for businesses, residential areas, and events. Our team is trained to handle both routine security needs and high-risk scenarios.",
   
  },
  {
    cover: "../images/service3.png",
    heading: "Facilities Services",
    text: " From janitorial services to maintenance and environmental safety, we manage the complete upkeep of your facilities, ensuring they operate smoothly and efficiently.",
  
  },
  {
    cover: "../images/service2.png",
    heading: "Property Management",
    text: "Aspire Security goes beyond basic security to offer property management services, handling everything from tenant management to maintenance oversight. We ensure your property remains secure, well-maintained, and fully operational.",
  
  },
 
]
export const list = [
  {
    id: 1,
    bgColor:"#FFDDC1",
    image: "strategy/mission2.png", // Replace with your image path
    heading: "Our Mission",
    content: "Our mission is to provide protection and security to our clients through a bespoke service tailored to their specific needs, ultimately the safety and security of the client’s staff, premises, assets and the general public is our highest priority..",
    //price: "$3,700",
    
  },
  {
    id: 2,
    bgColor: "#C1E1FF",
    image: "strategy/visio1.png",
    heading: "Our Vision",
    content: "We are committed to the ongoing improvement of the services we provide to our clients. By investing in and developing our most important assets, our staff, we aim to achieve all our goals and exceed our clients’ expectations. ",
    
   
  },
  {
    id: 3,
    bgColor: "#D9C1FF",
    image: "strategy/values1.png",
    heading: "Our Values",
    content: "As a company and as individuals we value above all else honesty, integrity, unselfishness, professionalism and mutual respect. For our staff, we offer a rewarding and challenging environment where personal development can flourish. We hold ourselves accountable to our clients, staff and partners by honoring our commitments, providing results and continually striving to provide the highest quality security services.",
   
   
  },
]
export const awards = [
  {
    icon: <i class='fa-solid fa-trophy'></i>,
    num: "32 M	",
    name: "Blue Burmin Award",
  },
  {
    icon: <i class='fa-solid fa-briefcase'></i>,
    num: "43 M",
    name: "Mimo X11 Award",
  },
  {
    icon: <i class='fa-solid fa-lightbulb'></i>,
    num: "51 M",
    name: "Australian UGC Award",
  },
  {
    icon: <i class='fa-solid fa-heart'></i>,
    num: "42 M",
    name: "IITCA Green Award",
  },
]
export const location = [
  {
    id: 1,
    name: "Madhapur",
    // Villas: "12 Villas",
   
    // Offices: "07 Offices",
    cover: "./images/location/d.jpg",
  },
  {
    id: 2,
    name: "Hi-TechCity",
    // Villas: "12 Villas",
    // Apartments: "10 Apartments",
    // Offices: "07 Offices",
    cover: "./images/location/cybertowers.jpg",
  },
  {
    id: 3,
    name: "Ameerpet",
    // Villas: "12 Villas",
    // Apartments: " 10 Apartments",
    // Offices: "07 Offices",
    cover: "./images/location/a.jpg",
  },
  {
    id: 4,
    name: "Kukatpally",
    // Villas: "12 Villas",
    // Apartments: " 10 Apartments",
    // Offices: "07 Offices",
    cover: "./images/location/k.jpg",
  },
  {
    id: 5,
    name: "Gachibowli",
    // Villas: "12 Villas",
    // Apartments: " 10 Apartments",
    // Offices: "07 Offices",
    cover: "./images/location/g.jpeg",
  },
  {
    id: 6,
    name: "Miyapur",
    // Villas: "10 Villas",
    // Apartments: " 10 Apartments",
    // Offices: "07 Offices",
    cover: "./images/location/city-1.png",
  },
]
export const team = [
  {
    list: "50",
    cover: "../images/customer/team-1.jpg",
    address: "Liverpool, Canada",
    name: "Sargam S. Singh",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "70",
    cover: "../images/customer/team-2.jpg",
    address: "Montreal, Canada",
    name: "Harijeet M. Siller",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "80",
    cover: "../images/customer/team-3.jpg",
    address: "Denever, USA",
    name: "Anna K. Young",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "51",
    cover: "../images/customer/team-4.jpg",
    address: "2272 Briarwood Drive",
    name: "Michael P. Grimaldo",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "42",
    cover: "../images/customer/team-5.jpg",
    address: "2272 Briarwood Drive",
    name: "Michael P. Grimaldo",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "38",
    cover: "../images/customer/team-5.jpg",
    address: "Montreal, USA",
    name: "Adam K. Jollio",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
]
export const price = [
  {
    plan: "Our Core Competencies",
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Manned Guarding",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Security Systems",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "House Keeping",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Property Management",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Pantry Services",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Product Procurement",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Pest Control",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Gardening ",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Backend Operations",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Front Desk Operations",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Data Entry",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Valet Services",
      },
    

    ],
  },
  {
    plan: "Sectors We Serve",
 
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Gated Communities",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Automobile Industry",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Retail Sector",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Software/Technology",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Educational Institutions",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Hospital & Health Care",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Banking&financial institution",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Research  and Development Organizations",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Laboratories",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Showrooms",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Service Centers and Malls",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Malls",
      },
    
     
    ],
  },
  {
    plan: "Manpower Categories",
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Facility and Security Manager",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Security Officer",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Assistant Security Officer",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Security Guards",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "House Keeping Supervisor",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Security Lady Guards",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Security Escort Guards",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Receptionists / Front Office Assistants",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Electricians & Mechanics",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Plumbers & Carpenters",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "House Keeping Staff",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Gardeners & Carpenters & Delivary Boys",
      },
      // {
      //   icon: <i class='fa-solid fa-check'></i>,
      //   text: "Delivery boys",
      // },
    ],
  },
]
export const imageSlide=[
  {
    url:'../images/background/b4.jpg',
    title:"aaaaaaa",
    body:"bbbbbbbb",

  },
  {
    url:'../images/background/b1.jpg',
    title:"aaaaaaab",
    body:"bbbbb",

  },
  {
    url:'../images/background/b2.jpg',
    title:"aaaaaaaa",
    body:"bbbbbb",

  },
]
export const footer = [
  // {
  //   title: "LAYOUTS",
  //   text: [{ list: "Home Page" }, { list: "About Page" }, { list: "Service Page" }, { list: "Property Page" }, { list: "Contact Page" }, { list: "Single Blog" }],
  // },
  {
    title: "QUICK LINKS",
    text: [{ list: "Home" }, { list: "About Us" }, { list: "Services" }, { list: "Contact Us" }],
  },
  {
    title: "FOLLOW US",
    text: [{ list: "Google",link:"https://www.justdial.com/jdmart/Hyderabad/Prem-Digitals-Best-Ads-Flex-Led-Sinage-Boards-Manufacturers-Nearby-Miyapur-Signal-X-Road-Beside-Testy-King-Bekers-Opposite-Sai-Teja-West-Side-Wine-ShopBollar-Miyapur/040PXX40-XX40-171226171153-Q4S4_BZDET/catalogue/photos" },
       { list: "FaceBook",link:"" }, { list: "Twitter",link:"" }, { list: "Instagram" ,link:""}],
    
  },
]
